(() => {
  const signupModalMain = document.getElementById("signupModalMain");
  if (!signupModalMain) return;
  try {
    const isV2 = signupModalMain.classList.contains('isV2');
    const locationPath = location.pathname.replace('/pages/latest', '').split('/');
    const country = locationPath[1];
    const lang = locationPath[2];
    if(!window.sessionStorage.getItem('AccountNumber')) {
      [{hostname: window.location.hostname, domain: false}, 
        {hostname: '.westernunion.com', domain: true}
      ].forEach(({hostname, domain}) => {
        CookieService.deleteCookie('SessionInfoRetail','/',hostname, domain);
        CookieService.deleteCookie('SessionInfo','/',hostname, domain);
        CookieService.deleteCookie('SessionIdRetail','/',hostname, domain);
        CookieService.deleteCookie('SessionDomainRetail','/',hostname, domain);
        CookieService.deleteCookie('SessionDomain','/',hostname, domain);
        CookieService.deleteCookie('sessionTimer','/',hostname, domain);
        // CookieService.deleteCookie('SessionId','/',hostname, domain);
        // CookieService.deleteCookie('EncryptedSessionId',`/${country}/${lang}`,hostname, domain);
        // CookieService.deleteCookie('EncryptedSessionId',`/`,hostname, domain);
        CookieService.deleteCookie('LangCode','/',hostname, domain);
        CookieService.deleteCookie('UserID','/',hostname, domain);
        CookieService.deleteCookie('NewUserCookie','/',hostname, domain);
        CookieService.deleteCookie('loggedIn','/',hostname, domain);
        CookieService.deleteCookie('CountryCode','/',hostname, domain);
        CookieService.deleteCookie('userType','/',hostname, domain);
        CookieService.deleteCookie('UserLocale','/',hostname, domain);
      })
      const sessionToRetain = window.sessionStorage.getItem('isQuickLoginEnabled') ? getSessionStorageItems(['isQuickLoginEnabled']) : [];
      window.sessionStorage.clear();
      setSessionStorageItems(sessionToRetain)
    }
    const rodeoRegistrationExperience = CookieService.getCookie('rodeoRegistrationExperience') === 'R4' || false;
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const passwordFormat = /((?=.*[a-z])(?=.*[A-Z])(?=.*[0123456789])^.{8,16}$)/;
    const nameFormat = /(?!(.)\1+$)(?!.*(.)\2{2})(?!.*( |-|')\3{1})(?=\S*(\s\S*){0,4}$)(?=[a-zA-ZÀ-ÿ .]*(['-][a-zA-ZÀ-ÿ .]*){0,2}$)(?=(.*[a-zA-ZÀ-ÿ.]){2}.*$)^[a-zA-ZÀ-ÿ '-.]{2,45}$/i;
    let signupEmailErrorText = signupModalMain.querySelector('.signupEmailId-error');
    let signupEmailErrorTextTwo = signupEmailErrorText.getAttribute('data-error-message-two');
    let passwordErrorText = signupModalMain.querySelector('.signupPassword-error');
    const signupEmailId = signupModalMain.querySelector("#signupEmailId");
    const signupPassword = signupModalMain.querySelector("#signupPassword");
    const btnTriggerAddCustomerApi = signupModalMain.querySelector("#btnTriggerAddCustomerApi");
    const eyeIconDisplayPassword = signupModalMain.querySelector('.eye-icon-display-password');
    const viewEyeIcon = eyeIconDisplayPassword.querySelector('.view-eye-icon');
    const hideEyeIcon = eyeIconDisplayPassword.querySelector('.hide-eye-icon');

    const signupFirstNameId = signupModalMain.querySelector("#signupFirstNameId");
    let signupFirstNameErrorText = signupModalMain.querySelector('.signupFirstNameId-error');
    let signupFirstNameErrorTextTwo = signupFirstNameErrorText && signupFirstNameErrorText.getAttribute('data-error-message-two');
    let signupFirstNameNotes = signupModalMain.querySelector('.signupFirstNameId-notes');   
    const signupLastNameId = signupModalMain.querySelector("#signupLastNameId");
    let signupLastNameErrorText = signupModalMain.querySelector('.signupLastNameId-error');
    let signupLastNameErrorTextTwo = signupLastNameErrorText && signupLastNameErrorText.getAttribute('data-error-message-two');
  

    let signupLastNameNotes = signupModalMain.querySelector('.signupLastNameId-notes');
    let enableFullRegistration = signupModalMain.getAttribute('data-full-registration');
    const signUpPrivacySettingId = signupModalMain.querySelector("#privacy_setting_checkbox");
    const signUpTermsConditionId = signupModalMain.querySelector("#terms_and_conditions_checkbox");
    const mywuTermsConditionId = signupModalMain.querySelector("#mywu_terms_condition");
    let signUpPrivacyErrorText = signupModalMain.querySelector('.checkbox_valid');

    const fullRegistration = enableFullRegistration && (enableFullRegistration == 'Y') ? true : false;

    const spinnerContainer = document.getElementById('spinnerContainer');
    let idleTime = signupModalMain.getAttribute('data-idle-timeout');
    const enterOtpDetails = signupModalMain.querySelector('#enterOtpDetails');
    const enterSignupDetails = signupModalMain.querySelector('#enterSignupDetails');
    const btnOtpValidate = signupModalMain.querySelector('#btnOtpValidate')
    const otpEl = signupModalMain.querySelectorAll('#enterOtpDetails .wu-input')
    const OtpErrorField = signupModalMain.querySelector('#OtpErrorField')
    const reenterThriceError = OtpErrorField?.getAttribute('reenter-thrice-error')
    const reEnterPin = OtpErrorField?.getAttribute('re-enter-pin')
    const otpSubtitle = signupModalMain.querySelector('#otpSubtitle')
    const otpSubtitleTextOnLoad = otpSubtitle?.innerText
    const loginTextButton = signupModalMain.querySelector("#logInText");
    const showSignUpButtonMain = signupModalMain.querySelector("#signupText");
    const resendPinLink = signupModalMain.querySelector("#resendPin");

    const inputLabels = signupModalMain.querySelectorAll('.input-label')
    Array.from(inputLabels).forEach((el) => {
      let labelEl = el.querySelector('label')
      let inputEL = el.querySelector('input')
      labelEl.addEventListener('click', () => {
        inputEL.focus()
      })
    })
    let r4SessionId = ''
    let r4encryptedSessionId = ''
    let r4ClientIp = ''
    let r4dataCenter = ''
    let countOfValidateOtp = 0

    signupEmailErrorText = signupEmailErrorText && signupEmailErrorText.innerText;
    passwordErrorText = passwordErrorText && passwordErrorText.innerText;

    signupFirstNameErrorText = fullRegistration && signupFirstNameErrorText && signupFirstNameErrorText?.innerText;
    signupLastNameErrorText = fullRegistration && signupLastNameErrorText && signupLastNameErrorText?.innerText;
  

    eyeIconDisplayPassword?.addEventListener('click', (event) => {
      const typeOfErrorInput = signupPassword.getAttribute('type')
      if (typeOfErrorInput === 'text') {
        signupPassword?.setAttribute('type', 'password')
        toggleClass(hideEyeIcon, 'd-inline', 'd-none')
        toggleClass(viewEyeIcon, 'd-none', 'd-inline')
      } else {
        signupPassword?.setAttribute('type', 'text')
        toggleClass(hideEyeIcon, 'd-none', 'd-inline')
        toggleClass(viewEyeIcon, 'd-inline', 'd-none')
      }
    })

    const  onKeyPressEventOfInputFields = (event) => {
      let elementId = event.currentTarget.id;
      let elementObject = document.getElementById(elementId);
      hideValidationMessage(elementObject);
    }

    const triggerEmailValidation = (emailAddressEL) => {
      if (emailAddressEL) {
        hideValidationMessage(emailAddressEL);
        let emailAddress = emailAddressEL.value;
        if (emailAddress !== undefined) {
          if (emailAddress == "") {
            showValidationMessage(emailAddressEL, signupEmailErrorText);
            emailAddressEL.focus();
            return false;
          } else if (!emailAddress.match(mailformat)) {
            showValidationMessage(emailAddressEL, signupEmailErrorTextTwo);
            emailAddressEL.focus();
            return false;
          } else {
            return true;
          }
        }
      }
    }

    const triggerNameValidation = (nameEL, nameErrorText,nameErrorTextTwo) => {
      if (nameEL) {
        hideValidationMessage(nameEL);
        let nameValue = nameEL.value;
        if (nameValue == "") {
          showValidationMessage(nameEL, nameErrorText);
          nameEL.focus();
          return false;
        } else if (!nameValue.match(nameFormat)) {
          showValidationMessage(nameEL, nameErrorTextTwo);
          nameEL.focus();
          return false;
        } else {
          return true;
        }
      }
    }

    const triggerPrivacySettingValidation = (privacyEL) => {
      if (!privacyEL.checked) {
         signUpPrivacyErrorText.classList.add("text-red");
        return false;
      } else {
        return true;
      }
    }

    signUpPrivacySettingId?.addEventListener('click', (event) => {
      if(event.target.checked){
        signUpTermsConditionId.checked = true;
      } else {
        signUpTermsConditionId.checked = false;
      }
    })

    mywuTermsConditionId?.addEventListener('click', (event) => {
      if(event.target.checked){
        mywuTermsConditionId.checked = true;
      } else {
        mywuTermsConditionId.checked = false;
      }
    })
   

    const eyeIconPlacement = (defaultEyeView=true) => {
      if(!isV2) return;
      let marginTop = (fullRegistration) ? 'top: 16%;' : 'top: 25%;';
      if(defaultEyeView) {
        eyeIconDisplayPassword.removeAttribute('style')
      } else {
        eyeIconDisplayPassword.setAttribute('style',marginTop)
      }
    }

    const triggerPasswordValidation = (passwordEL) => {
      if (passwordEL) {
        hideValidationMessage(passwordEL);
        eyeIconPlacement(true)
        let passwd = passwordEL.value;
        if (passwd !== undefined) {
          if (passwd == "") {
            showValidationMessage(passwordEL, passwordErrorText);
            eyeIconPlacement(false)
            passwordEL.focus();
            return false;
          } else if (!passwd.match(passwordFormat)) {
            showValidationMessage(passwordEL, passwordErrorText);
            eyeIconPlacement(false);
            passwordEL.focus();
            return false;
          } else {
            return true;
          }
        }
      }
    }

    function setDataInStorage(sessionId, encryptedSessionId, userData, country, customerProfile) {
      try {
        const accountNbr = customerProfile?.data?.customerProfile?.customer?.accountNumber
        const registrationDate = customerProfile?.data?.customerProfile?.customer?.registrationDate
        let sender = {};
        if(accountNbr){
          sender = {
            "email": userData.emailId,
            "verificationStatus": "N",
            "termsConditionFlag": "1",
            "myWuNumber": accountNbr,
            "isLoggedIn": true,
            "address": {
                "countryIsoCode": country.toUpperCase()
            },
            "additionalPreferedAccountNumber": accountNbr,
            "issueDate": registrationDate?.split(' ')[0]?.replace(/-/g,""),
            "mobileNumber": {},
            "identityVerificationStatus": "N",
            "accountPreferences": {
                "optOutMarketing": "true",
                "directMail": "false",
                "message": "false",
                "email": "true",
                "telephoneCall": "false",
                "optInShare": "true",
                "thirdpartyDatasharingConsent": "true",
                "whatsAppMsg": "false"
            },
            "registrationDetails": {
                "registrationDate": registrationDate,
                "registrationStatus": "P"
            },
            "customerLevelCode": customerProfile?.data?.customerProfile?.customer?.customerLevelCode// profile
          }
        } else {
          sender = {
            email: userData.emailId,
            password: userData.password
          }
        }
        const countryNameEl = document.querySelector("#footer-country-dropdown .b-flag-select__value");
        let receiverCountry = window.receiverCountry || 'MX';
        const receiverCountryName = countryCurrencyDefaults?.countries?.filter((cdata) => cdata.country.isCode === receiverCountry)[0]?.country?.name;
        const data = {
          sessionId: sessionId,
          encryptedSessionId: encryptedSessionId,
          sender: sender,
          corridor: {
            senderCountry: {
              isoCode: country.toUpperCase(),
              name: countryNameEl && countryNameEl.innerText
            },
            receiverCountry: {
              isoCode: receiverCountry,
              name: receiverCountryName
            },
            receiverCurrency: ISO_CODES_COUNTRIES_CURRENCIES[receiverCountry],
            senderCurrency: ISO_CODES_COUNTRIES_CURRENCIES[country.toUpperCase()],
            senderCurrencyArray: [{ currency: ISO_CODES_COUNTRIES_CURRENCIES[country.toUpperCase()] }],
            receiverCurrencyArray: [{ currency: ISO_CODES_COUNTRIES_CURRENCIES[receiverCountry] }],

          }
        };
        const jsonData = JSON.stringify(data);
        sessionStorage.setItem("app", jsonData);
        sessionStorage.setItem("cookiestore", jsonData);
        sessionStorage.setItem('sc_register_success', true);
        CookieService.setCookie('SessionId', sessionId, 30, '/', true, ".westernunion.com");
        CookieService.setCookie('EncryptedSessionId', encryptedSessionId, 30, `/${country}/${lang}`, true, ".westernunion.com");
      } catch(e) {
        console.log(e)
      }
    }

    if(signupEmailId.value) signupEmailId.setAttribute('value',signupEmailId.value)
    if(signupPassword.value) signupPassword.setAttribute('value',signupPassword.value)
    
    signupEmailId.addEventListener("keypress", onKeyPressEventOfInputFields);
    signupPassword.addEventListener("keypress", onKeyPressEventOfInputFields);

    if(signupFirstNameId !== null && signupFirstNameId.value && fullRegistration) signupFirstNameId.setAttribute('value',signupFirstNameId.value)
    if(signupLastNameId !== null && signupLastNameId.value && fullRegistration) signupLastNameId.setAttribute('value',signupLastNameId.value)

    fullRegistration && signupFirstNameId.addEventListener("keypress",onKeyPressEventOfInputFields);
    fullRegistration && signupLastNameId.addEventListener("keypress",onKeyPressEventOfInputFields);
    
    signupPassword.addEventListener("keypress",eyeIconPlacement);


    fullRegistration && signUpPrivacySettingId.addEventListener("change", function() {
      if (this.checked) {
        signUpPrivacyErrorText.classList.remove("text-red");
      }
    });

    let signupModelEl = [signupEmailId, signupPassword]; 
    if(fullRegistration){
      signupModelEl.push(signupFirstNameId,signupLastNameId);
    } 

    signupModelEl.forEach((el) => {
      el.addEventListener('input', (event) => {
        event.target.setAttribute("value", event.target.value)
      })
    })


    const otpElRedBkg = () => {
      otpEl?.forEach((el) => {
        el.classList.add("bdr-clr-rt-error", "bdr-clr-tp-error", "bdr-clr-bm-error", "bdr-clr-lt-error", "bdr-color-red")
      })
    }

    const errorScenarioTriggerOtp = (errorText) => {
      btnOtpValidate.removeAttribute('disabled')
      OtpErrorField?.classList.remove('d-none')
      if (countOfValidateOtp % 3 === 0 && OtpErrorField) {
        OtpErrorField.innerText = reenterThriceError
        resendTriggerOtp(true)
      } else if (OtpErrorField) {
        OtpErrorField.innerText = errorText || reEnterPin
      }
      hideSpinner()
      otpElRedBkg()
    }

    const resendTriggerOtp = (OtpErrorFieldShow) => {
      try {
        showSpinner()
        !OtpErrorFieldShow && OtpErrorField?.classList.add('d-none')
        window.queryData.triggerResendRecoveryFactor(country, lang, r4SessionId, signupEmailId.value) //call resend api
          .then((resp) => {
          }).catch(error => {
            showValidationApiError(error)
          }).finally(() => {
            hideSpinner()
          })
      } catch (e) {
        console.error('error from trigger register : ', e)
        hideSpinner()
      }
    }

    const triggerValidateOTP = (otp) => {
      const userData = {};
      userData.emailId = signupEmailId.value;
      userData.password = signupPassword.value;
      OtpErrorField?.classList.add('d-none')
      showSpinner()
      window.queryData.triggerRouterVerifyRecoveryFactor(otp, country, lang, r4SessionId) // verify pin api
        .then((otpResponse) => {
          if (otpResponse?.data?.verifyRecoveryFactor?.status === "SUCCESS") {
            triggerRouterSignInCustomer(r4SessionId, country, lang, userData) //sign api
              .then((signInData) => {
                if(signInData?.data?.signIn?.errorCode) {
                  errorScenarioTriggerOtp(signInData?.data?.signIn?.message)
                } else {
                  window.queryData.triggerCustomerProfile(r4SessionId, signInData?.data?.signIn?.token?.accessToken, country, lang).then(
                    (customerProfile) => {
                      if(customerProfile?.data?.customerProfile?.errorCode) {
                        errorScenarioTriggerOtp(customerProfile?.data?.customerProfile?.message)
                      } else {
                        setDataInStorageR4(customerProfile, signInData, lang, userData,country, r4SessionId, r4encryptedSessionId, r4ClientIp,r4dataCenter)
                        setDataInStorage(r4SessionId, r4encryptedSessionId, userData, country, customerProfile)
                        const accNumber = customerProfile?.data?.customerProfile?.customer?.accountNumber
                        sessionStorage.setItem('AccountNumber', accNumber);
                        const prepaidToken = signInData?.data?.signIn?.token?.prepaidToken || "";
                        sessionStorage.setItem('prepaidToken', prepaidToken);
                        const params = sendMoneyLink.getParam()
                        if(params) {
                          location.href = `/${country}/${lang}/web/send-money/estimate-details?${params}`
                        } else {
                          location.href = `/${country}/${lang}/web/send-money/start`
                        }
                      }
                    }).catch(e => {
                      errorScenarioTriggerOtp()
                    })
                }

              }).catch(e => {
                errorScenarioTriggerOtp()
              })
          } else {
            errorScenarioTriggerOtp()
          }
        }).catch(e => {
          errorScenarioTriggerOtp()
        })
    }

    btnOtpValidate?.addEventListener('click', (e) => {
      countOfValidateOtp++;
      e.target.setAttribute('disabled', true)
      let otp = ``
      for (let i = 0; i < otpEl.length; i++) {
        otp += otpEl[i].value
      }
      triggerValidateOTP(otp)
    })

    const hideSpinner = () => {
      spinnerContainer && toggleClass && toggleClass(spinnerContainer, 'd-flex', 'd-none')
    }

    const showSpinner = () => {
      spinnerContainer && toggleClass && toggleClass(spinnerContainer, 'd-none', 'd-flex')
    }

    const dataAddR4Customer = (country, lang, userData) => {
      btnTriggerAddCustomerApi.setAttribute('disabled', true)

      const showValidationApiError = (error, message) => {
        const messageLowerCase = message?.toLowerCase()
        if (messageLowerCase?.indexOf('email') !== -1) {
          showValidationMessage(signupEmailId, message)
        } else if (messageLowerCase?.indexOf('password') !== -1) {
          showValidationMessage(signupPassword, message)
          eyeIconPlacement(false)
        } else if (messageLowerCase) {
          showValidationMessage(signupEmailId, message)
        } else {
          showValidationMessage(signupEmailId, error?.error?.message)
        }
        btnTriggerAddCustomerApi.removeAttribute('disabled')
        hideSpinner()
      }

      try {
        showSpinner()
        if (otpSubtitle) otpSubtitle.innerText = otpSubtitle.innerText.replace('{{emailId}}', userData.emailId)
        triggerRouterCreateSession(country, lang) //add create session api
          .then(({ sessionId, encryptedSessionId, clientIp, dataCenter }) => {
            if (sessionId) {
              r4SessionId = sessionId
              r4encryptedSessionId = encryptedSessionId
              r4ClientIp = clientIp
              r4dataCenter = dataCenter
              triggerRouterAddCustomer(sessionId, country, lang, userData) // add customer api
                .then((reigsterResp) => {
                  if (reigsterResp?.data?.addCustomer?.status === 'CREATED' &&
                    reigsterResp?.data?.addCustomer?.["__typename"] === 'SuccessResponse') {
                    //location.href = `/${country}/${lang}/web/send-money/start`
                    getCustomerR4API( r4SessionId, r4encryptedSessionId, r4ClientIp, r4dataCenter, country, lang, userData)
                  }else if (reigsterResp?.data?.addCustomer?.error?.err === "EA1035") {
                    //show OTP screen
                    // submit click event for OTP button
                    enterOtpDetails?.classList.remove('d-none')
                    enterSignupDetails?.classList.add('d-none')
                    sessionStorage.setItem('sc_register_success', true);
                  } else if (reigsterResp?.data?.addCustomer["__typename"] === 'ErrorResponse') {
                    showValidationApiError(reigsterResp, reigsterResp?.data?.addCustomer?.message)
                  } else {
                    showValidationApiError(reigsterResp)
                  }
                  hideSpinner()
                }).catch(error => {
                  console.error(error)
                  showValidationApiError(error)
                  hideSpinner()
                })
            } else {
              hideSpinner()
              btnTriggerAddCustomerApi.removeAttribute('disabled')
            }
          }).catch(error => {
            console.error(error)
            hideSpinner()
            showValidationApiError(error)
          })
      } catch (e) {
        console.error('error from trigger register : ', e)
        hideSpinner()
      }

    };

    const dataAddR3Customer = (country, lang, userData) => {
      const createSessionCatalogConfig = triggerCreateSession(country, lang, location.host);
      btnTriggerAddCustomerApi.setAttribute('disabled', true)

      const showValidationApiError = (error) => {
        if (error?.error?.code === 'C1035') {
          showValidationMessage(signupPassword, error?.error?.message)
          eyeIconPlacement(false)
        } else {
          showValidationMessage(signupEmailId, error?.error?.message)
        }
        btnTriggerAddCustomerApi.removeAttribute('disabled')
        hideSpinner()
      }
      try {
        showSpinner()
        httpRequest.post(createSessionCatalogConfig.createSessionurl, createSessionCatalogConfig.reqPayload, { "Content-type": "application/json" })
          .then((response) => {
            const clientIp = response?.security?.client_ip ? response.security.client_ip : '245024209201'
            const sessionId = response?.security?.session.id
            const encryptedSessionId = response?.security?.session.encrypted_session_id
            setDataInStorage(sessionId, encryptedSessionId, userData, country);
            setCookieOnCreateSessionResponse(response);
            if (clientIp && sessionId) {
              triggerValidateEmail(userData.emailId, sessionId, clientIp)
                .then((validateEmailResp) => {
                  if (validateEmailResp?.error?.code === 'C6017') {
                    triggerRegisterGWPApi(sessionId, userData.emailId, userData.password, userData.name,userData.termsCondition, userData.optOutMarketing)
                      .then((reigsterResp) => {
                        if(reigsterResp?.error?.code === 'C6006') {
                            if (reigsterResp?.error?.reasons?.reason?.filter((reason) => reason.code === "11512")) {
                              const params = sendMoneyLink.getParam()
                              location.href = params ? `/${country}/${lang}/web/user/register-verify-email?${params}`
                                : `/${country}/${lang}/web/user/register-verify-email`
                            } else {
                              showValidationApiError(reigsterResp)
                            }
                        } else {
                          triggerCustomerSignOn(country, lang, sessionId, clientIp, userData, location.host)
                            .then((singOnResponse) => {
                              if (singOnResponse?.gatewayCustomer?.preferredCustomer?.accountNbr) {
                                    const accNumber = singOnResponse?.gatewayCustomer?.preferredCustomer?.accountNbr;
                                    setR3SendeGatewayrDetails(sessionId, encryptedSessionId, country, lang, userData, singOnResponse); 
                                    CookieService.setCookie('userIdentity', 'registeredCustomer', 365, location.pathname);      
                                    triggerGetLoyaltycards(sessionId, clientIp, accNumber, location.host).then((loyalityResponse) => {
                                      setR3LoyalityCard(loyalityResponse);                         
                                      location.href = `/${country}/${lang}/web/send-money/start`;
                                    }).catch(error => {
                                      console.error(error)
                                    showValidationApiError(error)
                                  })
                              } else {
                                showValidationApiError(singOnResponse);
                              }
                            }).catch(error => {
                              console.error(error)
                              showValidationApiError(error)
                            })
                        }
                      }).catch(error => {
                        console.error(error)
                        showValidationApiError(error)
                      })
                  } else {
                    showValidationApiError(validateEmailResp)
                  }
                }).catch(error => {
                  console.error(error)
                  showValidationApiError(error)
                })
            }
          }).catch(error => {
            console.error(error)
            showValidationApiError(error)
          })
      } catch (e) {
        console.error('error from trigger register : ', e)
        hideSpinner()
      }

    };

    const closeSignUpModal = () => {
      if(!fullRegistration){
        otpSubtitle.innerText =  otpSubtitleTextOnLoad
        enterOtpDetails?.classList.add('d-none')
        btnOtpValidate?.removeAttribute('disabled')
        OtpErrorField?.classList.remove('d-none')
      } 
      signupModalMain.classList.add('d-none')
      signupModalMain.classList.remove('d-flex')
      btnTriggerAddCustomerApi?.removeAttribute('disabled')
      enterSignupDetails?.classList.remove('d-none')
      hideValidationMessage(signupEmailId)
      hideValidationMessage(signupPassword)
      eyeIconPlacement(true)
      signupEmailId.value = ""
      signupPassword.value = ""
      if(fullRegistration){
        hideValidationMessage(signupFirstNameId)
        hideValidationMessage(signupLastNameId)
        signupLastNameId.value = ""
        signupFirstNameId.value = ""
      }
      CookieService.setCookie("signupClosed", "true");
    }

    const clickEventListenerModal = (e) => {
      if (e.target == signupModalMain) {
        closeSignUpModal()
      }
    }


    signupModalMain?.querySelector('.signUpClose').addEventListener('click', (event) => {
      closeSignUpModal();
    });

    // window.addEventListener('click', clickEventListenerModal)

    btnTriggerAddCustomerApi &&
      btnTriggerAddCustomerApi.addEventListener("click", function () {
        const userData = {};
        signupEmailId.value = signupEmailId.value?.trim();
        userData.emailId = signupEmailId.value?.trim();
        userData.password = signupPassword.value;
        const isEmailValid = triggerEmailValidation(signupEmailId);
        const isPasswordValid = triggerPasswordValidation(signupPassword);
        const username = {};
        username.first_name = signupFirstNameId && signupFirstNameId.value?.trim();
        username.last_name = signupLastNameId && signupLastNameId.value?.trim();
        const isFirstNameValid = triggerNameValidation(signupFirstNameId,signupFirstNameErrorText, signupFirstNameErrorTextTwo);
        (!isFirstNameValid) ? signupFirstNameNotes?.classList.add("d-none") : signupFirstNameNotes?.classList.remove("d-none");
        const isLastNameValid = triggerNameValidation(signupLastNameId,signupLastNameErrorText, signupLastNameErrorTextTwo);
        (!isLastNameValid) ? signupLastNameNotes?.classList.add("d-none") : signupLastNameNotes?.classList.remove("d-none");
        const isPrivacyValid = fullRegistration && triggerPrivacySettingValidation(signUpPrivacySettingId);
        userData.name = fullRegistration ? username : {};
        userData.termsCondition = (fullRegistration && signUpPrivacySettingId?.checked) || mywuTermsConditionId?.checked ? 1 : 0;       
        userData.optOutMarketing = (fullRegistration && signUpPrivacySettingId?.checked) ? true : false;
        isFirstNameValid && isLastNameValid && isEmailValid && isPasswordValid && isPrivacyValid && fullRegistration &&
          dataAddR3Customer(country, lang, userData)
        isEmailValid && isPasswordValid && !rodeoRegistrationExperience && !fullRegistration &&
          dataAddR3Customer(country, lang, userData)
        isEmailValid && isPasswordValid && rodeoRegistrationExperience && !fullRegistration &&
          dataAddR4Customer(country, lang, userData)
      });

    loginTextButton &&
      loginTextButton.addEventListener("click", function () {
        CookieService.setCookie("signupClosed", "true");
        location.href = `/${country}/${lang}/web/user/login`
      });

    showSignUpButtonMain &&
      showSignUpButtonMain.addEventListener("click", function () {
        signupModalMain?.classList.remove('d-none');
        signupModalMain?.classList.add('d-flex');
      });
    resendPinLink?.setAttribute("href","javascript:void(0)")

    resendPinLink?.addEventListener("click", function () {
      resendTriggerOtp()
    });


  } catch (e) {
    // Error handled silently for security
  }
})()

